import { Button, ButtonProps } from "../Buttons/Button";

export const DashboardIconButton = (props: Omit<ButtonProps, "variant" | "size" | "className">) => (
  <Button
    variant="ghost"
    size="md"
    className="animate-fade-in !p-2 hover:!bg-theme-primary-contrast hover:!text-theme-primary"
    {...props}
  />
);
